import { render, staticRenderFns } from "./NewPaymentsEdit.vue?vue&type=template&id=5ae568f6&scoped=true"
import script from "./NewPaymentsEdit.vue?vue&type=script&lang=js"
export * from "./NewPaymentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae568f6",
  null
  
)

export default component.exports